import { render } from "./ConversationMessageSkeleton.vue?vue&type=template&id=53c09423&scoped=true"
import script from "./ConversationMessageSkeleton.vue?vue&type=script&lang=js"
export * from "./ConversationMessageSkeleton.vue?vue&type=script&lang=js"

import "./ConversationMessageSkeleton.vue?vue&type=style&index=0&id=53c09423&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53c09423"]])

export default __exports__